import { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FaCheck, FaCheckCircle } from 'react-icons/fa';
import { Loading } from '../components/loading';
import { Modal } from '../components/modal';
import { PillButtons, Input, UrlsInput, Button, MultiSelect } from '../components/input';
import { RunVisit, RunCrawl, RunExtract, RunScrape } from '../components/run';
import { Select } from '../components/input';
import { Job, RawResults } from '../components/job';
import { FFSignInButton } from '../components/signin';
import { includeContentOptions, colors } from '../constants';
import { useGlobal } from '../state';

const Login = () => {
  return (
    <div
      style={{
        border: '1px solid #ccc',
        borderRadius: 10,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 20,
        width: 360,
        margin: '20px auto',
        textAlign: 'center',
      }}
    >
      <div>To use the API, sign up for a free account</div>
      <FFSignInButton style={{ width: 200 }}>Sign Up</FFSignInButton>

      <div>Already have an account?</div>
      <FFSignInButton style={{ width: 200 }} outline>
        Sign In
      </FFSignInButton>
    </div>
  );
};

const TryIt = ({ url }) => {
  const { apiKey } = useGlobal();
  const [tab, setTab] = useState('visit');
  const [job, setJob] = useState();
  const [jobId, setJobId] = useState();
  const [starting, setStarting] = useState();
  const [loading, setLoading] = useState();
  const [took, setTook] = useState();
  const [showLogin, setShowLogin] = useState();
  const tookRef = useRef();

  const padding = 10;
  const tabStyle = {
    border: '1px solid #fff',
    flex: 1,
    padding,
    cursor: 'pointer',
  };

  const nameStyle = {
    fontWeight: 'bold',
    fontSize: 12,
    fontFamily: 'monospace',
    textAlign: 'center',
  };

  const textStyle = {
    fontSize: 12,
    display: 'none',
  };

  const activeStyle = {
    border: `1px solid ${colors.primary}`,
    background: colors.primary,
    color: 'white',
    padding: padding,
    borderRadius: 10,
  };

  const blurbStyle = {
    fontSize: 14,
    marginBottomx: 10,
    padding: 10,
  };

  const runStyle = {
    border: '1px solid #ccc',
    background: 'white',
    margin: 3,
    padding: 10,
    borderRadius: 10,
  };

  const active = (style, t) => (t == tab ? { ...style, ...activeStyle } : style);

  const handleSubmit = () => {
    setJobId();
    setTook();
    setStarting(true);
  };

  const handleErrors = (errors) => {
    alert('todo: handle errors: ' + errors);
    setStarting(false);
  };

  const handleStart = () => {
    if (!apiKey) {
      setShowLogin(true);
      return;
    }

    const start = new Date().getTime();
    const update = () => {
      const took = new Date().getTime() - start;
      setTook((took / 1000).toFixed(2) + 's');
    };

    if (tookRef.current) {
      clearInterval(tookRef.current);
    }

    tookRef.current = setInterval(update, 20);

    setJob(null);
    setJobId(null);
    setStarting(true);
    setLoading(true);
  };

  const handleJob = (job) => {
    setStarting(false);
    setJob(null);
    setJobId(job.id);
  };

  const handleFinished = (data) => {
    setLoading(false);
    setStarting(false);
    setJob(data);
    clearInterval(tookRef.current);
  };

  const node = {
    visit: (
      <div stylex={{ border: '1px solid #eee', background: '#eee', borderRadius: 10 }}>
        <div style={blurbStyle}>
          The <b>visit</b> endpoint takes a <b>one or more URLs</b> and returns the content.
        </div>
        <div style={runStyle}>
          <RunVisit
            attach
            params={{ urls: [url], include: ['markdown', 'html', 'urls'], proxy: 'none', visiter: 'playwright' }}
            hideAdvanced
            inlineResults
            onStart={handleStart}
            onJob={handleJob}
            onFinished={handleFinished}
          />
        </div>
      </div>
    ),

    crawl: (
      <>
        <div style={blurbStyle}>
          The <b>crawl</b> endpoint takes a <b>URL pattern</b> and finds a list of matching <b>URLs</b>.
        </div>
        <div style={runStyle}>
          <RunCrawl hideAdvanced inlineResults onStart={handleStart} onJob={handleJob} onFinished={handleFinished} />
        </div>
      </>
    ),

    extract: (
      <>
        <div style={blurbStyle}>
          The <b>extract</b> endpoint takes <b>URLs and a template</b> converts them into <b>structured data</b>.
        </div>
        <div style={runStyle}>
          <RunExtract hideAdvanced inlineResults onStart={handleStart} onJob={handleJob} onFinished={handleFinished} />
        </div>
      </>
    ),

    scrape: (
      <>
        <div style={blurbStyle}>
          The <b>scrape</b> endpoint uses a <b>URL pattern</b> and an <b>item template</b> to generate structured data.
          It is a combination of crawl and extract.
        </div>
        <div style={runStyle}>
          <RunScrape hideAdvanced inlineResults onStart={handleStart} onJob={handleJob} onFinished={handleFinished} />
        </div>
      </>
    ),
  }[tab];

  const size = 14;
  const color = loading ? '#333' : '#888';

  const jobNode = (
    <div style={{ opacity: starting ? 0.5 : 1 }}>
      {jobId && <Job slim id={jobId} />}
      {!jobId && job && <Job slim job={job} />}
    </div>
  );

  const resultsNode = (
    <div style={{ marginTop: 20 }}>
      <h2>Results</h2>

      <div
        style={{
          border: '1px solid #ccc',
          borderRadius: 10,
          padding: 10,
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, color }}>
            <div style={{ width: size, height: size, display: 'flex', alignItems: 'center' }}>
              {loading && <Loading color={color} size={size} />}
              {!loading && <FaCheck size={size * 0.7} />}
            </div>
            <div style={{ fontFamily: 'monospace', fontSize: size * 0.9 }}>{took}</div>
          </div>

          {job && (
            <div>
              <Modal title={`Raw results for ${job.name || ''} job ${job.id || ''}`}>
                <Button grayFlat small>
                  Raw
                </Button>
                <RawResults results={job} />
              </Modal>
            </div>
          )}
        </div>

        {(jobId || job) && jobNode}
      </div>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <h1>API Sandbox</h1>

      <PillButtons
        wrapperStylex={{ widthx: '100%', background: '#fff', borderRadius: 10, borderx: `1px solid #ccc` }}
        pillStyle={{ flexx: 1, width: 100, paddingx: 15, color: '#777', borderRadius: 10 }}
        activeStyle={{ fontWeight: 'bold' }}
        highlightStylex={{ background: '#ccc', marginTop: 1, borderRadius: 8 }}
        choices={[
          ['visit', 'Visit'],
          ['extract', 'Extract'],
          ['crawl', 'Crawl'],
          ['scrape', 'Scrape'],
        ]}
        value={tab}
        onChange={setTab}
      />

      {node}

      {(starting || jobId || job) && resultsNode}

      {showLogin && <Login />}
    </div>
  );
};

export default function Sandbox() {
  const location = useLocation();

  return (
    <div>
      <TryIt url={location.state?.url || ''} />
    </div>
  );
}
